import { useReducedMotion } from "framer-motion";
import { useEffect, useState } from "react";
import { useHydrated } from "@/hooks/useHydrated";

/**
 * REGEL: Jede Animation der Website fragt diesen Hook ab.
 * Liefert true, wenn nicht animiert werden darf — entweder weil das
 * Betriebssystem "Bewegung reduzieren" meldet oder weil der Viewport klein
 * ist (Handy: schwere Scroll-/Pointer-Effekte bleiben dort aus).
 */
export const useReducedMotionSafe = () => {
  const prefersReduced = useReducedMotion();
  const hydrated = useHydrated();
  // REGEL: Betriebssystem-Präferenzen verändern nie den ersten Server-/Browseraufbau.
  return hydrated && Boolean(prefersReduced);
};

/** True, sobald der Viewport mindestens Tablet-Breite hat (>= 768px). */
export const useIsDesktopViewport = () => {
  const [isDesktop, setIsDesktop] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) return;
    const mq = window.matchMedia("(min-width: 768px)");
    const update = () => setIsDesktop(mq.matches);
    update();
    mq.addEventListener("change", update);
    return () => mq.removeEventListener("change", update);
  }, []);

  return isDesktop;
};

/** Schwere Effekte (Parallax, Maus-Licht) nur auf Desktop und ohne Reduce-Motion. */
export const useRichMotionEnabled = () => {
  const reduced = useReducedMotionSafe();
  const isDesktop = useIsDesktopViewport();
  return isDesktop && !reduced;
};
